import React, { createContext, useCallback } from "react";
import list from "../sources/variables/companies.json";

const innerTexts = list.filter(x => x.id === process.env.REACT_APP_BUILDTYPE)[0] || {};

const StepContext = createContext({});

let siblingSteps = {
  ileri: null,
  geri: null,
  currentAction: null,
};

export const StepContextProvider = (Step, wizardConfig) => {

  const StepWithContext = (currentWizardProps) => {

    const { currentWizardProps: parentWizardProps } = useWizardContext();

    const ileri = () => {
      siblingSteps.currentAction = 'ileri';
      if (currentWizardProps?.totalSteps === currentWizardProps?.currentStep && parentWizardProps?.nextStep) {
        parentWizardProps.nextStep()
      } else {
        currentWizardProps.nextStep();
      }
    }

    const geri = () => {
      siblingSteps.currentAction = 'geri';
      currentWizardProps.previousStep();
      // Step back within the current wizard when possible and not on its first step
      if (currentWizardProps?.previousStep && parentWizardProps?.previousStep && currentWizardProps?.currentStep === 1) {
        parentWizardProps.previousStep();
        return;
      }

      // If this company skips an intermediate step, jump directly to step 1 of the parent wizard
      // if (innerTexts?.noYerindelikUygunlukStep && parentWizardProps?.goToStep) {
      //   parentWizardProps.goToStep(1);
      //   return;
      // }

      // Otherwise bubble up to the parent wizard
      // if (parentWizardProps?.previousStep) {
      //   parentWizardProps.previousStep();
      //   return;
      // }

      // Last resort: try current previousStep even if on first step
      // if (currentWizardProps?.previousStep) {
      //   currentWizardProps.previousStep();
      // }
    }

    const ctxValues = { stepname: Step.name, innerTexts, currentWizardProps, parentWizardProps, ileri, geri, }

    if (wizardConfig?.viewHider && currentWizardProps.isActive) {
      const isSkipView = wizardConfig?.viewHider(ctxValues);
      if (isSkipView) {

        if (siblingSteps.currentAction === 'geri') {
          geri();
          return null;
        } else {
          ileri();
          return null;
        }
      }
    }

    if (!currentWizardProps.isActive) {
      return null;
    }

    console.log({ ...ctxValues, isActive: currentWizardProps.isActive });

    return (
      <StepContext.Provider value={ctxValues}>
        <Step {...currentWizardProps} />
      </StepContext.Provider>
    );
  };

  StepWithContext.displayName = `StepWithContext(${Step.name || Step.displayName || "Unnamed"})`;

  return StepWithContext;
};

export function useWizardContext() {
  return React.useContext(StepContext);
}
